import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericErrorScreen, GenericModal, GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup.jsx';

import Title from './Title.jsx';
import Header from './Header.jsx';
import Table from './Table.jsx';
import NuevoPerfil from './NuevoPerfil.jsx';
import PopUpEdicion from './PopUpEdicion.jsx';

class PerfilesyPermisos extends Component {
    constructor(props) {
        super(props);

        this.callFunction = this.callFunction.bind(this);
        
        if (window.performance) {
            if (performance.navigation.type == 1) {
                this.callFunction()
            }
        }
    }

    callFunction(){
        this.props.resetStatePerfyPerm();
    }


    // componentDidUpdate() {
    //     $('[data-toggle="tooltip"]').tooltip();
    // }

    componentDidMount() {
        this.props.getScreenData(this.props.currentScope);
        //   $('[data-toggle="tooltip"]').tooltip();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.data.messageHidden) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }
    }

    componentWillUnmount() {
        this.props.resetStatePerfyPerm();
    }

    render() {
        const { data } = this.props;

        let spinner = null;

        if (data.isFetching == true)
            spinner = <div className="loading" />

        let message = (data.profileSelected.userCount > 0) ?
            <p>{data.profileSelected.userCount +
                " usuario/s tienen asignado este perfil, al eliminarlo desaparecerá también la información relacionada a él de forma permanente ¿Quiere eliminar el perfil?"}
            </p> :
            <p>¿Quiere eliminar el perfil?</p>;

        return (
            <div className="container-fluid concierge">
                {spinner}

                {/*POP UP*/}
                <MessagePopup isHidden={data.messageHidden}
                    message={data.message}
                    classMessage={data.messageClass} />

                <Title titulo="Perfiles y permisos" />
                <Header functions={data.functions} />
                <Table data={data}
                    selectProducto={this.props.selectProducto}
                    selectCategoria={this.props.selectCategoria}
                    selectPrograma={this.props.selectPrograma}
                    setPerfilEdicion={this.props.setPerfilEdicion}
                    setInfoPerfilToDelete={this.props.setInfoPerfilToDelete}
                    buscarPerfil={this.props.buscarPerfil} />

                {/*MODALES*/}
                <NuevoPerfil data={data}
                    nuevoPerfil={this.props.nuevoPerfil}
                    limpiarMensajes={this.props.limpiarMensajes}
                    configuracionSesion={this.props.data.configuracionSesion}
                    gruposWindows={this.props.data.gruposWindows}
                    addGroupWindows={this.props.addGroupWindows}
                    deleteGroupWindows={this.props.deleteGroupWindows}
                    stopClear={this.props.stopClear}
                    startClear={this.props.startClear} />

                <PopUpEdicion id={"editProfileModal"}
                    editErrorMessage={data.editErrorMessage}
                    editErrorMessageDescripcion={data.editErrorMessageDescripcion}
                    descripcion={data.profileSelected.descripcion}
                    nameProfile={data.profileSelected.codigo}
                    limpiarMensajes={this.props.limpiarMensajes}
                    editarPerfil={this.props.editarPerfil}
                    productoId={data.profileSelected.productoId}
                    data={data}
                    configuracionSesion={this.props.data.configuracionSesion}
                    gruposWindows={data.profileSelected.gruposWindows}
                    addGroupWindowsEdit={this.props.addGroupWindowsEdit}
                    deleteGroupWindowsEdit={this.props.deleteGroupWindowsEdit} />

                <GenericModal type="ALL_CUSTOM"
                    className="modal fade-out"
                    id="deleteProfileModal"
                    screenSize="modal-dialog modal-generic"
                    header={
                        <h2 className="modal-title">Eliminar perfil</h2>}
                    footer={
                        <div className="row">
                            <div className="col-xs-4">
                                <button className="btn btn-primary btn-cta" onClick={this.props.eliminarPerfil}>Eliminar</button>
                            </div>
                            <div className="col-xs-8">
                                <GenericSimpleButton text="Cancelar" dataDismiss="modal" buttonClass="btn btn-default btn-secondary" />
                            </div>
                        </div>}
                    body={<p>{message}</p>} />
            </div>
        );
    }
}

export default PerfilesyPermisos;